import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const festivalFilterCriteria = (
  isMobileVersion,
  styles,
  isChartsMode
) => {
  return isChartsMode
    ? [
        {
          title: "Location",
          isHide: false,
          isLocation: true,
        },
        {
          icon: Images.iconCalendarColored,
          width: 20,
          height: 20,
          title: "Date",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 1,
              label: moment().subtract(1, "year").format("YYYY"),
              tagId: moment().subtract(1, "year").format("YYYY"),
            },
            {
              id: 2,
              label: moment().format("YYYY"),
              tagId: moment().format("YYYY"),
            },
            {
              id: 3,
              label: moment().add(1, "year").format("YYYY"),
              tagId: moment().add(1, "year").format("YYYY"),
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_MUSIC,
          icon: Images.iconTagMusic,
          width: 20,
          height: 20,
          title: "Music",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 0,
              label: "All",
              tagId: 300,
            },
            {
              id: 1,
              label: "Electronic",
              tagId: 301,
            },
            {
              id: 2,
              label: "Pop",
              tagId: 302,
            },
            {
              id: 3,
              label: "Rock",
              tagId: 303,
            },
            {
              id: 4,
              label: "Hip-Hop",
              tagId: 304,
            },
            {
              id: 5,
              label: "R&B",
              tagId: 305,
            },
            {
              id: 6,
              label: "Reggae",
              tagId: 306,
            },
            {
              id: 7,
              label: "Jazz",
              tagId: 307,
            },
            {
              id: 8,
              label: "Blues",
              tagId: 308,
            },
            {
              id: 9,
              label: "Metal",
              tagId: 309,
            },
            {
              id: 10,
              label: "Punk",
              tagId: 310,
            },
            {
              id: 11,
              label: "Country",
              tagId: 311,
            },
            {
              id: 12,
              label: "Folk",
              tagId: 312,
            },
            {
              id: 13,
              label: "Latin",
              tagId: 313,
            },
            {
              id: 14,
              label: "Classical",
              tagId: 314,
            },
            {
              id: 15,
              label: "Religious",
              tagId: 315,
            },
            {
              id: 16,
              label: "Mix",
              tagId: 9999,
            },
          ],
          selectedList: [],
        },
        {
          icon: Images.iconTagEventType,
          width: 20,
          height: 20,
          title: "Category",
          isHide: false,
          isSingle: true,
          isMinimumOneSelect: true,
          detailList: [
            {
              id: 1,
              label: "Popularity",
              tagId: Constants.sortByAction.SORT_BY_SOCIAL_MEDIA_POPULARITY,
            },
            {
              id: 2,
              label: "Lineup Size",
              tagId: Constants.sortByAction.SORT_BY_LINEUP_SIZE,
            },
            {
              id: 3,
              label: "Lineup Popularity",
              tagId: Constants.sortByAction.SORT_BY_LINEUP_POPULARITY,
            },
          ],
          selectedList: [Constants.sortByAction.SORT_BY_LINEUP_POPULARITY],
        },
      ]
    : [
        {
          title: "Location",
          isHide: isMobileVersion,
          isLocation: true,
        },
        {
          icon: Images.iconCalendarColored,
          width: 20,
          height: 20,
          title: "Date",
          isHide: false,
          // isHide: !isSearch,
          isDate: true,
          dateType: "anytime",
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_STATUS,
          icon: Images.iconTagStatus,
          width: 20,
          height: 20,
          title: "Status",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Upcoming - Confirmed",
            },
            {
              id: 2,
              label: "Upcoming - To Be Confirmed",
            },
            {
              id: 3,
              label: "Upcoming - Live",
            },
            {
              id: 4,
              label: "Upcoming - Cancelled",
            },
            {
              id: 5,
              label: "Upcoming - Rescheduled",
            },
            {
              id: 6,
              label: "Past",
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_EVENT_TYPE,
          icon: Images.iconTagEventType,
          width: 20,
          height: 20,
          title: "Event type",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Concert",
              tagId: 101,
              isDisabled: true,
            },
            {
              id: 2,
              label: "Party",
              tagId: 102,
              isDisabled: true,
            },
            {
              id: 3,
              label: "Festival",
              tagId: 103,
            },
            {
              id: 4,
              label: "Other",
              tagId: 104,
              isDisabled: true,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_MUSIC,
          icon: Images.iconTagMusic,
          width: 20,
          height: 20,
          title: "Music",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Electronic",
              tagId: 301,
            },
            {
              id: 2,
              label: "Pop",
              tagId: 302,
            },
            {
              id: 3,
              label: "Rock",
              tagId: 303,
            },
            {
              id: 4,
              label: "Hip-Hop",
              tagId: 304,
            },
            {
              id: 5,
              label: "R&B",
              tagId: 305,
            },
            {
              id: 6,
              label: "Reggae",
              tagId: 306,
            },
            {
              id: 7,
              label: "Jazz",
              tagId: 307,
            },
            {
              id: 8,
              label: "Blues",
              tagId: 308,
            },
            {
              id: 9,
              label: "Metal",
              tagId: 309,
            },
            {
              id: 10,
              label: "Punk",
              tagId: 310,
            },
            {
              id: 11,
              label: "Country",
              tagId: 311,
            },
            {
              id: 12,
              label: "Folk",
              tagId: 312,
            },
            {
              id: 13,
              label: "Latin",
              tagId: 313,
            },
            {
              id: 14,
              label: "Classical",
              tagId: 314,
            },
            {
              id: 15,
              label: "Religious",
              tagId: 315,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_PARTICIPATION,
          icon: Images.iconTagParticipation,
          width: 20,
          height: 20,
          title: "Participation",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "In-person only",
              tagId: 201,
            },
            {
              id: 2,
              label: "In-person & Virtual",
              tagId: 203,
            },
            {
              id: 3,
              label: "Virtual only",
              tagId: 202,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_ENTRY,
          icon: Images.iconTagEntry,
          width: 20,
          height: 20,
          title: "Entry",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Guestlist",
              tagId: 1201,
            },
            {
              id: 2,
              label: "Table",
              tagId: 1202,
            },
            {
              id: 3,
              label: "Tickets",
              tagId: 1203,
            },
            {
              id: 4,
              label: "Door",
              tagId: 1204,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_PRICE,
          icon: Images.iconTagPrice,
          width: 20,
          height: 20,
          title: "Price",
          isHide: false,
          isPrice: true,
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_RATING,
          icon: Images.iconTagRating,
          width: 21.5,
          height: isMobileVersion ? 21 : 20,
          title: "Rating",
          isHide: true,
          isRating: true,
          detailList: [
            {
              id: 1,
              label: "1",
              prefixIcon: (
                <View style={styles.row}>
                  <CImage
                    source={Images.iconTagRating1}
                    width={isMobileVersion ? 16 : 24}
                    height={isMobileVersion ? 16 : 24}
                    layout="fixed"
                  />
                </View>
              ),
            },
            {
              id: 2,
              label: "2",
              prefixIcon: (
                <View style={styles.row}>
                  <CImage
                    source={Images.iconTagRating2}
                    width={isMobileVersion ? 16 : 24}
                    height={isMobileVersion ? 16 : 24}
                    layout="fixed"
                  />
                </View>
              ),
            },
            {
              id: 3,
              label: "3",
              prefixIcon: (
                <View style={styles.row}>
                  <CImage
                    source={Images.iconTagRating3}
                    width={isMobileVersion ? 16 : 24}
                    height={isMobileVersion ? 16 : 24}
                    layout="fixed"
                  />
                </View>
              ),
            },
            {
              id: 4,
              label: "4",
              prefixIcon: (
                <View style={styles.row}>
                  <CImage
                    source={Images.iconTagRating4}
                    width={isMobileVersion ? 16 : 24}
                    height={isMobileVersion ? 16 : 24}
                    layout="fixed"
                  />
                </View>
              ),
            },
            {
              id: 5,
              label: "5",
              prefixIcon: (
                <View style={styles.row}>
                  <CImage
                    source={Images.iconTagRating5}
                    width={isMobileVersion ? 16 : 24}
                    height={isMobileVersion ? 16 : 24}
                    layout="fixed"
                  />
                </View>
              ),
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_FEATURES,
          icon: Images.iconTagLightning,
          width: 20,
          height: 20,
          title: "Features",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Upscale",
              tagId: 601,
            },
            {
              id: 2,
              label: "Elegant",
              tagId: 602,
            },
            {
              id: 3,
              label: "Underground",
              tagId: 603,
            },
            {
              id: 4,
              label: "Casual",
              tagId: 604,
            },
            {
              id: 5,
              label: "Alternative",
              tagId: 605,
            },
            {
              id: 6,
              label: "International",
              tagId: 606,
            },
            {
              id: 7,
              label: "Local",
              tagId: 607,
            },
            {
              id: 8,
              label: "Live Music",
              tagId: 608,
            },
            {
              id: 9,
              label: "Rooftop",
              tagId: 609,
            },
            {
              id: 10,
              label: "LGBT",
              tagId: 610,
            },
            {
              id: 11,
              label: "Students",
              tagId: 611,
            },
            {
              id: 12,
              label: "Members",
              tagId: 612,
            },
            {
              id: 13,
              label: "Pool",
              tagId: 613,
            },
            {
              id: 14,
              label: "VIP",
              tagId: 614,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_DURATION,
          icon: Images.iconTagDuration,
          width: 20,
          height: 20,
          title: "Duration",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "0 - 3h",
              tagId: 405,
            },
            {
              id: 2,
              label: "3h - 6h",
              tagId: 406,
            },
            {
              id: 2,
              label: "6h - 1 Day",
              tagId: 407,
            },
            {
              id: 3,
              label: "2 Days",
              tagId: 403,
            },
            {
              id: 4,
              label: "+3 Days",
              tagId: 404,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_VENUE,
          icon: Images.iconTagTagVenue,
          width: 20,
          height: 20,
          title: "Venue",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Club",
              tagId: 701,
            },
            {
              id: 2,
              label: "Bar",
              tagId: 702,
            },
            {
              id: 3,
              label: "Hall",
              tagId: 703,
            },
            {
              id: 4,
              label: "Stadium",
              tagId: 704,
            },
            {
              id: 5,
              label: "Open Air",
              tagId: 705,
            },
            {
              id: 6,
              label: "Other",
              tagId: 706,
            },
            {
              id: null,
              label: null,
              isSeparator: true,
            },
            {
              id: 7,
              label: "Indoor & Outdoor",
              tagId: 801,
            },
            {
              id: 8,
              label: "Indoor Only",
              tagId: 802,
            },
            {
              id: 9,
              label: "Outdoor Only",
              tagId: 803,
            },
          ],
          selectedList: [],
        },
        {
          icon: Images.iconSearchArtist,
          width: 20,
          height: 20,
          title: "Lineup",
          isHide: false,
          isLineup: true,
          detailList: [
            {
              id: 1,
              label: "0",
              value: { value: 0 },
            },
            {
              id: 2,
              label: "1",
              value: { value: 1 },
            },
            {
              id: 3,
              label: "2-4",
              value: { minValue: 2, maxValue: 4 },
            },
            {
              id: 4,
              label: "5-19",
              value: { minValue: 5, maxValue: 19 },
            },
            {
              id: 5,
              label: "20-49",
              value: { minValue: 20, maxValue: 49 },
            },
            {
              id: 6,
              label: "+50",
              value: { minValue: 50 },
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_SIZE,
          icon: Images.iconTagSize,
          width: 20,
          height: 20,
          title: "Size",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "XXS",
              suffix: "0 - 200",
              tagId: 501,
            },
            {
              id: 2,
              label: "XS",
              suffix: "200 - 500",
              tagId: 502,
            },
            {
              id: 3,
              label: "S",
              suffix: "500 - 2K",
              tagId: 503,
            },
            {
              id: 4,
              label: "M",
              suffix: "2K - 5K",
              tagId: 504,
            },
            {
              id: 5,
              label: "L",
              suffix: "5K - 20K",
              tagId: 505,
            },
            {
              id: 6,
              label: "XL",
              suffix: "20K - 50K",
              tagId: 506,
            },
            {
              id: 7,
              label: "XXL",
              suffix: "50K+",
              tagId: 507,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_AREA,
          icon: Images.iconTagArea,
          width: 20,
          height: 20,
          title: "Area",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "City",
              tagId: 901,
            },
            {
              id: 2,
              label: "Town",
              tagId: 902,
            },
            {
              id: 3,
              label: "Countryside",
              tagId: 903,
            },
            {
              id: 4,
              label: "Field",
              tagId: 904,
            },
            {
              id: 5,
              label: "Forest",
              tagId: 905,
            },
            {
              id: 6,
              label: "Lake",
              tagId: 906,
            },
            {
              id: 7,
              label: "Beach",
              tagId: 907,
            },
            {
              id: 8,
              label: "Mountain",
              tagId: 908,
            },
            {
              id: 9,
              label: "Park",
              tagId: 909,
            },
            {
              id: 10,
              label: "Resort",
              tagId: 910,
            },
            {
              id: 11,
              label: "Unique Location",
              tagId: 911,
            },
            {
              id: 12,
              label: "Ship",
              tagId: 912,
            },
            {
              id: 13,
              label: "Other",
              tagId: 913,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_ACCOMODATION,
          icon: Images.iconTagAccomodation,
          width: 20,
          height: 20,
          title: "Accommodation",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "No camping",
              tagId: 1401,
            },
            {
              id: 2,
              label: "Camping",
              suffix: "Car parking",
              tagId: 1402,
            },
            {
              id: 1403,
              label: "Camping",
              suffix: "RC / Van parking",
              tagId: 1403,
            },
            {
              id: 4,
              label: "Camping",
              suffix: "Tent area",
              tagId: 1404,
            },
            {
              id: 1405,
              label: "Camping",
              suffix: "Tent",
              tagId: 1405,
            },
            {
              id: 6,
              label: "Camping",
              suffix: "Glamping",
              tagId: 1406,
            },
            {
              id: 7,
              label: "Hotel",
              tagId: 1407,
            },
          ],
          selectedList: [],
        },
        {
          id: Constants.tagCategory.TAG_CATEGORY_DRESS_CODE,
          icon: Images.iconTagDressCode,
          width: 20,
          height: 20,
          title: "Dress Code",
          isHide: false,
          detailList: [
            {
              id: 1,
              label: "Casual",
              tagId: 1001,
            },
            {
              id: 2,
              label: "Smart",
              tagId: 1002,
            },
            {
              id: 3,
              label: "Elegant",
              tagId: 1003,
            },
          ],
          selectedList: [],
        },
        {
          icon: Images.iconTagAge,
          width: 20,
          height: 20,
          title: "Age",
          isHide: false,
          isAge: true,
        },
      ];
};
